export default __webpack_public_path__ + "static/media/reedem.1182ad8b.svg";